import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMatch, useConfirmReset } from '../hooks/useMatch';
import { MatchHeader } from '../components/match/MatchHeader';
import { MatchBoard } from '../components/match/MatchBoard';
import { ResetModal } from '../components/match/ResetModal';
import { Button } from '../components/ui/Button';
import './MatchPage.css';

export function MatchPage() {
  const { matchId } = useParams<{ matchId: string }>();
  const navigate = useNavigate();
  const { data: match, isLoading, error } = useMatch(matchId);
  const confirmReset = useConfirmReset(matchId || '');
  const [showResetModal, setShowResetModal] = useState(false);

  const handleConfirmReset = async () => {
    try {
      await confirmReset.mutateAsync(true);
      setShowResetModal(false);
    } catch (error) {
      console.error('Failed to reset match:', error);
    }
  };

  const handleCancelReset = async () => {
    try {
      await confirmReset.mutateAsync(false);
      setShowResetModal(false);
    } catch (error) {
      console.error('Failed to cancel reset:', error);
    }
  };

  if (isLoading) {
    return (
      <div className="match-page match-page--loading">
        <div className="loading-container">
          <div className="loading loading--large" />
          <p className="loading-text">Carregando partida...</p>
        </div>
      </div>
    );
  }

  if (error || !match) {
    return (
      <div className="match-page match-page--error">
        <div className="error-container">
          <h2>Erro ao carregar partida</h2>
          <p>{error?.message || 'Partida não encontrada'}</p>
          <Button onClick={() => navigate('/')}>Voltar</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="match-page">
      <div className="container">
        <MatchHeader matchId={match.id} />
        <MatchBoard match={match} />

        {match.status === 'finished' && (
          <div className="match-finished-banner">
            <h2>Partida Finalizada!</h2>
            <p>
              Vencedor: {match.winner === 'sideA' ? match.players.sideA.name : match.players.sideB.name}
            </p>
          </div>
        )}

        <div className="match-actions">
          <Button
            variant="outline"
            onClick={() => setShowResetModal(true)}
            disabled={confirmReset.isPending}
          >
            Solicitar Reset
          </Button>
        </div>
      </div>

      <ResetModal
        isOpen={showResetModal}
        onConfirm={handleConfirmReset}
        onCancel={handleCancelReset}
        isLoading={confirmReset.isPending}
      />
    </div>
  );
}
